export function getView(type) {
  return type !== 'wait'
}
